<template>
  <div v-if="showLGPD" style="background-color: black; width: 100%; position: fixed; z-index: 200; opacity: 90%">
      <v-layout row justify-center>
          <v-dialog v-model="showLGPD"
            persistent max-width="730" max-height="700">      
            <v-card
              style="max-height: 730px;"
            >
              <v-card-text style=" padding:20px; justify-content: center; overflow-y: auto !important; max-height: 700px">
                <v-layout  column gap-xl ml-3 mt-3 mb-3 style="padding: 20px">
                  <h2 v-html="termText" style="margin: 0; text-align: center;"></h2>
                    </v-layout>
              </v-card-text>
              <v-card-actions class="pa-0 p-2">
                <div class="footer-modal-atividades" style="justify-content: space-between !important;">
                  <v-radio
                      label="Não autorizo."
                      @change="openDeclineLGPD"
                    ></v-radio>
                  <v-radio
                      label="Sim, autorizo."
                      @change="openAcceptLGPD"
                    ></v-radio>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <AucAlert
          ref="declineLGPDRef"
          title="Você confirma que NÃO autoriza?"
          confirmButtonText="Sim"
          cancelButtonText="Não"
          @confirm="decline"
        />
        <AucAlert
          ref="acceptLGPDRef"
          title="Você confirma que autoriza?"
          confirmButtonText="Sim"
          cancelButtonText="Não"
          @confirm="accept"
        />
  </div>
</template>

<script type="plain/text">
// Services
import CampaignService from "@/scripts/services/campaign.service";
import UserCompanyConsentTermService from "@/scripts/services/userCompanyConsentTerm.service";

// Models
import UserCompanyConsentTerm from "../scripts/models/userCompanyConsentTerm.model";

//Components
import AucAlert from "@/components/AucAlert.vue";

//VUEX
import { mapGetters, mapActions } from "vuex";

export default {
  props: ['dialog'],
  components: {
    AucAlert,
  },
  data() {
    return {
      campaignService: new CampaignService(),
      userCompanyConsentTermService: new UserCompanyConsentTermService(),
      userCompanyConsentTerm: new UserCompanyConsentTerm(),
      showLGPD: false,
      accepted: false,
    };
  },
  watch: {
    logged(val) {
      if (val) {
        this.detectLGPD();
      }
    },
  },
  computed: {
    ...mapGetters([
      'logged',
      'userProfile',
      'campaignLandingPageConfig',
    ]),
    termText() {
      return this.campaignLandingPageConfig.campaign.company.lgpdText ?
        this.campaignLandingPageConfig.campaign.company.lgpdText : 'Deseja receber comunicações futuras desta organização?';
    }
  },
  created() {
    this.setLandingPageConfig();
  },
  methods: {
    ...mapActions([
      'setLandingPageConfig'
    ]),
    async detectLGPD() {
      this.showLGPD = await this.campaignService.showLGPD();
    },
    openAcceptLGPD() {
      this.$refs.acceptLGPDRef.open();
    },
    openDeclineLGPD() {
      this.$refs.declineLGPDRef.open();
    },
    accept() {
      this.accepted = true;
      this.save();
    },
    decline() {
      this.save();
    },
  async save() {
        this.userCompanyConsentTerm.userId = this.userProfile.userId;
        this.userCompanyConsentTerm.companyId = this.campaignLandingPageConfig.campaign.company.id
        this.userCompanyConsentTerm.ipAddress = await this.getIP();
        this.userCompanyConsentTerm.accepted = this.accepted;

        this.userCompanyConsentTermService.save(this.userCompanyConsentTerm)
          .then((response) => {
            this.showLGPD = false;
          })
    },
    async getIP() {
      try {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        return data.ip;
      } catch (error) {
        console.error('Erro ao buscar o IP:', error);
        return null
      }
    },
  },
}
</script>